import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
const badges = ['150 Ready-to-Teach Classes', '6 Complete Visual Volumes', '5 Exclusive Bonuses', 'Beginner to Advanced', 'Instant Digital Access'];
const trustItems = ['6 Complete Volumes', '5 Exclusive Bonuses', 'Completely Visual', 'Instant Access'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-12 px-4 overflow-hidden bg-stone-50" data-id="element-150" data-mp="xa4gd9pdu5e0">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-151" data-mp="saruosa8z4d0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-152" data-mp="nc87kojx3mj2">
          <p className="inline-block px-3 py-1 rounded-full border border-rose-700/30 bg-stone-100 text-rose-900 font-semibold text-[10px] sm:text-sm tracking-widest uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-153" data-mp="3j7zg1kyg9whq">
            Makeup Instructor Ready
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-stone-800" data-id="element-154" data-mp="39cfmh57cz9w5">
            Solve an entire year of{' '}
            <span className="text-rose-700" data-id="element-155" data-mp="30ggdtgc92mgr">makeup classes</span> in just 5
            minutes.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-xs sm:max-w-xl md:max-w-3xl mb-4 sm:mb-6" data-id="element-156" data-mp="35akmq552t4kh">
          <img src="https://cdn.magicpatterns.com/uploads/6c2vQddLJh4wvuWYfD4vTu/Diseno_sin_titulo_(65).png" alt="Makeup Instructor Ready — six visual volumes, class finder tablet and five bonus guides" className="relative z-10 w-full h-auto" data-id="element-157" data-mp="2lmld4xm903gn" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-158" data-mp="ddf2ya44fm8r">
          <p className="text-sm sm:text-lg md:text-xl font-semibold text-stone-800 leading-snug max-w-2xl mx-auto mb-2" data-id="element-159" data-mp="111es55lsb4l8">
            The Complete 6-in-1 Visual Teaching System for Makeup Educators
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-stone-600 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-160" data-mp="3lui8konbuvkb">
            150 Ready-to-Teach Classes, Step-by-Step Visual Techniques, Student
            Practice, Instructor Corrections, Assessments & Professional
            Teaching Tools — organized and ready to use.
          </p>

          <ul className="flex flex-wrap justify-center gap-2 mb-6 sm:mb-7" data-id="element-161" data-mp="269zkfyxrx7r1">
            {badges.map(badge => <li key={badge} className="bg-rose-900 text-white text-[10px] sm:text-xs font-semibold uppercase tracking-wider rounded-full px-3 py-1.5" data-id="element-162" data-mp="2b196yqo0zuyp">
                {badge}
              </li>)}
          </ul>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-163" data-mp="2l0qc96zd86u5">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-164" data-mp="2p1s8rg1we4sf">
              GET MAKEUP INSTRUCTOR READY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-stone-500" data-id="element-165" data-mp="zndrthx4fm7h">
            {trustItems.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-166" data-mp="3vgnhqt3c1xrd">
                <CheckCircle size={14} className="text-rose-700" aria-hidden="true" data-id="element-167" data-mp="e9a5m0znusjk" />
                <span data-id="element-168" data-mp="9b8ohllsp3aq">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}